/**
 * Created by liujintao on 18/9/5.
 */
if (process.env.VUE_ENV === 'server') {
    document = {cookie: ''};
    localStorage = {};
    localStorage.getItem = localStorage.setItem = localStorage.get = localStorage.set = localStorage.remove = localStorage.removeItem = function () {
        return '';
    };
    location = {};
}
module.exports = {
    document: document,
    localStorage: localStorage,
    location: location
};



// WEBPACK FOOTER //
// ./src/common/libs/hack-env.js